/*global jQuery*/
(function ($) {
    'use strict';

    $('table').wrap('<div class="table-responsive"></div>');
}(jQuery));